import {Component, DestroyRef, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {MatFormField, MatPrefix} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatOption} from '@angular/material/core';
import {MatSelect} from '@angular/material/select';
import {MatTooltip} from '@angular/material/tooltip';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';

@Component({
  selector: 'app-select-multiple',
  standalone: true,
  imports: [
    MatFormField,
    MatIcon,
    MatOption,
    MatPrefix,
    MatSelect,
    MatTooltip,
    FormsModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule
  ],
  templateUrl: './select-multiple.component.html',
  styleUrl: './select-multiple.component.css'
})
export class SelectMultipleComponent implements OnChanges, OnInit {
  private readonly destroyRef = inject(DestroyRef);
  @Input() listaInput: any[] = [];
  @Input() itensSelecionado: any[] = [];

  @Input() label?: string;
  @Input() colorLabel?: string;

  @Input() placeholder = '';
  @Input() campo = '';
  @Input() subCampo = '';

  @Input() chaveCompare = '';

  @Input() iconPrefix?: string;
  @Input() iconColor?: string;

  @Input() widthFormField = '100%';
  @Input() heightFormField = '60px';

  @Input() backgroundColor?: string;

  @Input() carregandoInfo?: boolean = false;

  @Input() font?: string;

  @Input() isMobile = false;

  @Input() disabled = false;
  @Input() habilitarBusca = true;

  @Output() selecionarItem = new EventEmitter<any>();

  filtroControl = new FormControl('');
  listaOriginal: any[] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes['itensSelecionado'] != 'undefined') {
      if (typeof changes['itensSelecionado'].currentValue != 'undefined') {
        this.itensSelecionado = changes['itensSelecionado'].currentValue;
      }
    }
    if (changes['listaInput']) {
      this.listaOriginal = [...(changes['listaInput'].currentValue ?? [])];
      this.filtrarLista(this.filtroControl.value ?? '');
    }
  }

  ngOnInit(): void {
    this.listaOriginal = [...this.listaInput];
    this.filtroControl.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(busca => this.filtrarLista(busca ?? ''));
  }

  onChange() {
    this.selecionarItem.emit(this.itensSelecionado);
  }

  compararListas(v1: any, v2: any): boolean {
    return v1 && v2 ? v1.id && v2.id ? v1.id === v2.id : v1 === v2 : v1 === v2;
  }

  private filtrarLista(busca: string): void {
    const termo = busca.trim().toLocaleLowerCase('pt-BR');
    this.listaInput = !termo
      ? [...this.listaOriginal]
      : this.listaOriginal.filter(item => this.textoItem(item).toLocaleLowerCase('pt-BR').includes(termo));
  }

  private textoItem(item: any): string {
    if (!this.campo) return String(item ?? '');
    return this.subCampo
      ? `${item?.[this.campo] ?? ''} - ${item?.[this.subCampo] ?? ''}`
      : String(item?.[this.campo] ?? '');
  }
}
